module.exports = __webpack_public_path__ + "static/media/transf3.cc997df6.jpg";